import { useContext } from 'react';

import { CanduProviderContext } from './CanduProviderContext';
import { CanduReactProviderContextType } from './defaultProviderContext';

export const useCanduContext: () => CanduReactProviderContextType = () =>
  useContext(CanduProviderContext);
